import React from 'react';

export const LeafLogo = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.7242 3.30504C20.6546 3.04646 20.4524 2.84461 20.1937 2.77546C19.935 2.7063 19.659 2.78033 19.4697 2.96969C19.3431 3.09622 19.2122 3.23232 19.0748 3.3752C17.9142 4.58222 16.2887 6.27259 12.8939 6.75756C9.13938 7.29392 6.25 9.80622 6.25 13.5C6.25 14.326 6.39837 15.1174 6.66991 15.8489C7.57301 15.4264 8.6194 15.0719 9.81821 14.7722C12.8149 14.0231 14.9256 12.1428 16.3924 10.1152C16.6352 9.77955 17.1041 9.7043 17.4397 9.94707C17.7753 10.1899 17.8505 10.6587 17.6078 10.9943C16.0013 13.215 13.6187 15.3683 10.182 16.2274C9.06254 16.5073 8.1265 16.8276 7.34609 17.1887C8.55116 19.032 10.6333 20.25 13 20.25C15.1621 20.25 18.0547 19.4402 19.9239 16.8094C21.7943 14.177 22.5033 9.913 20.7242 3.30504Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66991 15.8477C5.81823 16.2461 5.09398 16.7051 4.48951 17.2358C3.22323 18.3475 2.53491 19.7277 2.26032 21.3753C2.19222 21.7839 2.46824 22.1703 2.87681 22.2384C3.28539 22.3065 3.67181 22.0305 3.73991 21.6219C3.96531 20.2695 4.50595 19.2174 5.47914 18.363C5.97028 17.9319 6.58397 17.5402 7.34609 17.1875C7.07355 16.7706 6.84587 16.3217 6.66991 15.8477Z"
        fill="black"
      />
    </svg>
  );
};
